import React, { useEffect } from 'react';
import { Fancybox } from "@fancyapps/ui";
import { formatFileSize } from "../../util/formatFileSize";
import Image from "../elements/Image";

const OrderDetailsFileItem = ({ index, data, convertedData }) => {
  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: {
        autoStart: false,
      },
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY",
          ],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Images: {
        zoom: true,
      },
      mainClass: "fancybox-custom",
    });
    return () => {
      Fancybox.destroy();
    };
  }, []);

  return (
    <>
      <div key={index} className="flex items-center gap-1 md:gap-2 2xl:gap-4 py-4">
        {/* Original File */}
        <div className="w-[45%] 2xl:w-[44%] flex-shrink flex items-center gap-4">
          <div className="w-28 2xl:w-40 3xl:w-48 aspect-square 2xl:aspect-[4/3] 3xl:aspect-[3/2] border border-md-pink-light-1 overflow-hidden rounded-lg 2xl:rounded-xl flex flex-shrink-0 transition-all duration-300 hover:shadow-md hover:shadow-md-pink/20">
            <a
              href={data?.image}
              data-fancybox={`image-pair-${index}`}
              data-caption={`Original: ${data?.filename} (${formatFileSize(data?.size)})`}
              className="w-full h-full flex group"
            >
              <Image
                src={data?.image || ""}
                alt={data?.filename || ""}
                width={"100%"}
                height={"100%"}
                effect={"blur"}
                classes={"object-cover !transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"}
              />
            </a>
          </div>
          <div className="flex-shrink flex-grow space-y-2 2xl:space-y-3 truncate">
            <div className="space-y-0.5">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">Filename</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none truncate" title={data?.filename?.split('.')[0]}>{data?.filename?.split('.')[0]}</div>
            </div>
            <div className="space-y-0.5">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">File Size</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none">{formatFileSize(data?.size)}</div>
            </div>
            <div className="space-y-0.5">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">File Extension</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none uppercase">{data?.extension || 'N/A'}</div>
            </div>
          </div>
        </div>

        {/* Separator */}
        <div className="w-[calc(12%-2rem)] flex-shrink-0">
          <div className="hidden 2xl:block 2xl:text-[10px] font-semibold uppercase !leading-none text-slate-400 text-center">Converted to</div>
          <div className="text-center text-md-pink text-2xl 2xl:text-3xl">
            <i className="fa-light fa-arrow-right-long"></i>
          </div>
        </div>

        {/* Converted File */}
        <div className="w-[45%] 2xl:w-[44%] flex-shrink flex items-center gap-4 flex-row-reverse">
          <div className="w-28 2xl:w-40 3xl:w-48 aspect-square 2xl:aspect-[4/3] 3xl:aspect-[3/2] border border-md-pink-light-1 overflow-hidden rounded-lg 2xl:rounded-xl flex flex-shrink-0 transition-all duration-300 hover:shadow-md hover:shadow-md-pink/20">
            <a
              href={convertedData?.[index]?.image}
              data-fancybox={`image-pair-${index}`}
              data-caption={`Converted: ${convertedData?.[index]?.filename} (${formatFileSize(convertedData?.[index]?.size)})`}
              className="w-full h-full flex group"
            >
              <Image
                src={convertedData?.[index]?.image || ""}
                alt={convertedData?.[index]?.filename || ""}
                width={"100%"}
                height={"100%"}
                effect={"blur"}
                classes={"object-cover !transition-all duration-300 group-hover:scale-110 group-hover:rotate-3"}
              />
            </a>
          </div>
          <div className="flex-shrink flex-grow text-right space-y-2 2xl:space-y-3 truncate">
            <div className="space-y-0.5">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">Filename</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none truncate" title={convertedData?.[index]?.filename?.split('.')[0]}>{convertedData?.[index]?.filename?.split('.')[0]}</div>
            </div>
            <div className="space-y-0.5">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">File Size</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none">{formatFileSize(convertedData?.[index]?.size)}</div>
            </div>
            <div className="space-y-0.5">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">File Extension</div>
              <div className="text-sm 2xl:text-base font-medium !leading-none uppercase">{convertedData?.[index]?.extension || 'N/A'}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetailsFileItem;